import {
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  numberedEnv,
  localizeKey,
  sentryDSNKey,
  isNumberedEnv,
  OAUTH_PROVIDERS_EU,
  COOKIE_POLICY_URL,
  DATA_PROCESSING_AGREEMENT_URL,
  PRIVACY_POLICY_URL,
  TERMS_OF_SERVICE_URL,
} from "@src/runtime-config-base";
import { RuntimeConfig } from "@src/runtime-config-types";

export const runtimeConfig: RuntimeConfig = {
  environment: "dev",
  appRegion: "eu",
  appEnv: "eu-dev",
  urls: {
    apiBaseUrl: "https://core.api.dev.holobuilder.eu",
    projectApiUrl: "https://v2.project.api.dev.holobuilder.eu",
    viewerUrl:
      numberedEnv === "dev1"
        ? "https://dev1.viewer.dev.holobuilder.eu"
        : "https://viewer.dev.holobuilder.eu",
    webEditorUrl: "https://app.dev.holobuilder.eu/app",
    apiBaseComUrl: "https://core.api.dev.holobuilder.com",
    apiBaseEuUrl: "https://core.api.dev.holobuilder.eu",
    sphereDashboardUrl:
      numberedEnv === "dev1"
        ? "https://dev1.sphere.dev.holobuilder.eu"
        : "https://sphere.dev.holobuilder.eu",
    dashboard20ComUrl:
      numberedEnv === "dev1"
        ? "https://dev1.sphere.dev.holobuilder.com"
        : "https://sphere.dev.holobuilder.com",
    dashboard20EuUrl:
      numberedEnv === "dev1"
        ? "https://dev1.sphere.dev.holobuilder.eu"
        : "https://sphere.dev.holobuilder.eu",
    sphereEntryPageComUrl:
      numberedEnv === "dev1"
        ? "https://dev1.entry.dev.holobuilder.com"
        : "https://entry.dev.holobuilder.com",
    sphereEntryPageEuUrl:
      numberedEnv === "dev1"
        ? "https://dev1.entry.dev.holobuilder.eu"
        : "https://entry.dev.holobuilder.eu",
    sphereEntryPageApi: "https://entry.dev.holobuilder.eu/api",
    termsOfServiceUrl: TERMS_OF_SERVICE_URL,
    privacyPolicyUrl: PRIVACY_POLICY_URL,
    dataProcessingAgreementUrl: DATA_PROCESSING_AGREEMENT_URL,
    cookiePolicyUrl: COOKIE_POLICY_URL,
  },
  features: {
    localizeKey,
    sentryDSNKey,
  },
  oauth: {
    providers: OAUTH_PROVIDERS_EU,
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support-eu+dev@holobuilder.com",
  isNumberedEnv,
  numberedEnv,
};
